"use strict";
import { Box } from "nft/components/Box";
import * as styles from "nft/components/modals/Overlay.css";
import noop from "utilities/src/react/noop";
export const stopPropagation = (event) => {
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation();
};
export const Overlay = ({ onClick = noop }) => {
  return <Box className={styles.overlay} onClick={onClick} />;
};
